/**
 * True when the role is SuperAdmin regardless of common API/SSO variants
 * (e.g. "SuperAdmin", "superadmin", "Super Admin").
 */
export function isSuperAdminRole(role: unknown): boolean {
  if (role == null) return false;
  const normalized = String(role).replace(/\s+/g, '').toLowerCase();
  return normalized === 'superadmin';
}
